import { Analysis } from 'common-spectrum';
import { appendedParser } from 'ndim-parser';
import { appendUnits, getDensities } from './utils';
const metaVarHeaders = [
    'Analysis.Setup.Vector.Graph.XAxis',
    'Analysis.Setup.Vector.Graph.YAxis',
    'Analysis.Setup.Vector.List.Datum',
    'Function.User',
];
export function metaUnits(meta) {
    let knownUnits = {};
    for (const key of metaVarHeaders) {
        const keyName = `${key}.${"Name" /* name */}`;
        const keyUnits = `${key}.${"Unit" /* units */}`;
        if (meta[keyName] && meta[keyUnits]) {
            const names = meta[keyName].split(',');
            const units = meta[keyUnits].split(',');
            for (let index = 0; index < names.length; index++) {
                const [label] = getDensities(names[index]);
                if (label === 'Q_dens') {
                    // TODO the existing parser doesn't recognize electron charge units
                    knownUnits[label] = 'uC/mm';
                }
                else {
                    knownUnits[label] = units[index];
                }
            }
        }
    }
    return knownUnits;
}
export default class BaseB1505 {
    constructor(xLabel, yLabel, scale) {
        this.xLabel = xLabel;
        this.yLabel = yLabel;
        this.scale = scale;
        this.calculations = [];
    }
    addCalculation(name, calculation) {
        this.calculations.push([name, calculation]);
    }
    parseMeta(meta) {
        if (!meta)
            return {};
        let ans = {};
        for (const key in meta) {
            ans[key] = meta[key]
                .split(',')
                .filter((val) => val !== '')
                .join(',');
        }
        // add default kind scale
        const { xLabel, yLabel, scale } = this;
        ans['default.xLabel'] = xLabel;
        ans['default.yLabel'] = yLabel;
        ans['default.scale'] = scale;
        return ans;
    }
    parseText(text) {
        const series = appendedParser(text);
        let analyses = [];
        for (const { data, meta } of series) {
            const parsedMeta = this.parseMeta(meta);
            const knownUnits = metaUnits(meta);
            let analysis = new Analysis();
            analysis.pushSpectrum(appendUnits(data, knownUnits), {
                title: parsedMeta.Remarks ||
                    parsedMeta['TestRecord.Remarks'] ||
                    parsedMeta['Device ID'] ||
                    parsedMeta['Setup title'] ||
                    parsedMeta.SetupTitle,
                meta: parsedMeta,
            });
            for (const [name, calculation] of this.calculations) {
                const spectrum = analysis.getXYSpectrum({
                    xLabel: this.xLabel,
                    yLabel: this.yLabel,
                });
                if (spectrum) {
                    const result = JSON.stringify(calculation(spectrum));
                    if (result) {
                        if (spectrum.meta) {
                            spectrum.meta[name] = result;
                        }
                        else {
                            spectrum.meta = { [name]: result };
                        }
                    }
                }
            }
            analyses.push(analysis);
        }
        return analyses;
    }
}
//# sourceMappingURL=data:application/json;base64,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